var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.radioStyle == "button"
        ? _c(
            "el-radio-group",
            {
              attrs: { disabled: _vm.mode !== "edit" || _vm.disabled },
              model: {
                value: _vm.selectedValue,
                callback: function($$v) {
                  _vm.selectedValue = $$v
                },
                expression: "selectedValue"
              }
            },
            _vm._l(_vm.choices, function(choice) {
              return _c(
                "el-radio-button",
                {
                  key: choice.value,
                  attrs: { label: choice.value, disabled: choice.disabled }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("capitalize")(choice.label)) +
                      "\n            "
                  ),
                  choice.sublabel
                    ? _c(
                        "p",
                        {
                          staticClass: "mt-1 mb-0 regular",
                          class: _vm.btnTextColor(choice.value)
                        },
                        [_vm._v(_vm._s(_vm._f("capitalize")(choice.sublabel)))]
                      )
                    : _vm._e()
                ]
              )
            }),
            1
          )
        : _c(
            "el-radio-group",
            {
              attrs: { disabled: _vm.mode !== "edit" || _vm.disabled },
              model: {
                value: _vm.selectedValue,
                callback: function($$v) {
                  _vm.selectedValue = $$v
                },
                expression: "selectedValue"
              }
            },
            _vm._l(_vm.choices, function(choice) {
              return _c(
                "el-radio",
                {
                  key: choice.value,
                  attrs: { label: choice.value, disabled: choice.disabled }
                },
                [_vm._v(_vm._s(choice.label))]
              )
            }),
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }